@if ((driver$ | async) || !isCarousel) {
  <div class="image-box">
    <img [src]="(driver$ | async)?.avatarUrl || DEFAULT_AVATAR" alt="driver">
    @if (isDriverEditAvailable) {
      <button mat-icon-button class="edit-button" (click)="editDriver()">
        <mat-icon>edit</mat-icon>
      </button>
    }
  </div>
}

<div class="driver">
  @if ((driver$ | async) || !isCarousel) {
    <div class="info">
      <div class="item-info">
        <span class="title">{{ 'term.name' | translate }}: </span>
        <span>{{ (driver$ | async)?.getFullName() }}</span>
      </div>
      <div class="item-info">
        <span class="title">{{ 'term.telephone' | translate }}: </span>
        <span>{{ (driver$ | async)?.phoneNumber }}</span>
      </div>
    </div>
  }

  <div class="dialog-box-buttons">
    @if (driver$ | async) {
      <button mat-button class="button" (click)="removeDriver()">
        {{ 'action.remove' | translate }}
      </button>
    }
    @if (isDriverAvailable && isDriverAssignAvailable) {
      <button mat-button class="app-button primary" (click)="assignDriver()">{{ 'action.assign' | translate }}</button>
    }
  </div>
</div>
